export default __webpack_public_path__ + "static/media/third.a9bf6d2d.svg";